export default "__VITE_ASSET__ba6Da6eL__"